<div class="export-selector" (click)="$event.stopPropagation()">
  <lib-button
    variant="primary"
    type="button"
    [disabled]="disabled()"
    [loading]="loading()"
    (clicked)="toggleMenu()"
  >
    {{ label() }}
  </lib-button>

  @if (open()) {
    <div class="export-selector__backdrop" (click)="cancel()" aria-hidden="true"></div>
    <div class="export-selector__dialog-wrap">
      <div class="export-selector__panel" role="dialog" aria-modal="true" aria-label="Configurar descarga">
        <div class="export-selector__header">
          <h3 class="export-selector__title">Descargar reporte</h3>
          <button
            type="button"
            class="export-selector__close-btn"
            (click)="cancel()"
            [disabled]="loading()"
            aria-label="Cerrar"
          >
            ✕
          </button>
        </div>

        <div class="export-selector__body">
          <lib-select
            label="Formato"
            [options]="options()"
            [value]="selectedFormat()"
            (valueChange)="onFormatChange($event)"
          />
        </div>

        <div class="export-selector__footer">
          <lib-button variant="secondary" type="button" [disabled]="loading()" (clicked)="cancel()">
            Cancelar
          </lib-button>
          <lib-button
            variant="primary"
            type="button"
            [disabled]="!selectedFormat() || loading()"
            [loading]="loading()"
            (clicked)="confirmDownload()"
          >
            Descargar
          </lib-button>
        </div>
      </div>
    </div>
  }
</div>
